import { Route } from "vue-router";

export * from "../api/types_common";
export * from "../api/types_payment";
export * from "../api/types_vending";

import {
  ClientPermission,
  ResultTerminal,
  BaseCompany,
  BaseBranch,
  BasePermission,
  Device,
  BranchSummary,
  CommerceCodes,
  UserCustomClaims
} from "../api/types_common";
import { StoreOptions } from "vuex";
import firebase from "firebase/app";
import { LangData } from "@/lib/language";

/*****************************************************
 *                Types for ./store                  *
 ****************************************************/

export interface Company extends BaseCompany {
  address: string[];
  branchesSummaries: BranchSummary[];
  branches?: Branch[];
  filteredBranch?: FilteredBranch[];
}

export interface FilteredBranch {
  branch: BranchSummary;
  name: string;
  tcod: string | null;
  searchTerm: string | null;
}

export interface Branch extends BaseBranch {
  address: string[];
  terminals?: Terminal[];
  manualClose: boolean;
  devices?: Device[];
  commerceCodes?: CommerceCodes[];
}

export interface Terminal extends ResultTerminal {
  device: Device | null;
  serialNumber: number | null;
}

export interface User {
  uid: string;
  isToken: boolean;
  name: string | null;
  email: string | null;
  isGlobalAdmin: boolean;
  requiresReinforcedLogin?: boolean;
  isLoading: boolean;
  permissions: Permission[];
  fbUser: firebase.User;
  needsReinforced: boolean;
  claims: Partial<UserCustomClaims> | null;
}

export interface Permission extends ClientPermission {
  companyID?: number;
}

export interface PartialPermission extends BasePermission {
  user: User | null;
  company: Company | null;
  branchIDs: number[];
  isLoading: boolean;
  isLogged: boolean;
  isGlobalAdmin: boolean;
  adminCompanies: number[];
  isAdminOfAny: boolean;
  isReinforced: boolean;
}

export type WebsiteStore = StoreOptions<RootState>;

export interface RootState {
  currentUser: User | null;
  currentUserLoading: boolean;
  needsReinforcedLogin: boolean;
  reinforcedLoginNotice: string;
  redirectAfterLogin: string | Route;
  lastError: unknown;
  selectedCompanyLoading: boolean;
  selectedCompany: Company | null;
  userCompaniesLoading: boolean;
  userCompanies: Company[] | null;
  lang: LangDataOption;
  branch: null | number;
}
export type langKey = "ES" | "EN";

export interface LangDataOption {
  key: langKey;
  name: string;
  data: LangData;
}
export interface VueForm extends Vue {
  validate(): boolean;
  $el: HTMLFormElement;
  reset(): void;
  resetValidation(): void;
}

export interface VueRoot extends Vue {
  isMobile: boolean;
}
